import { createAsyncStore } from "../common/axios/asyncModel";
import { TermsRepository } from "repository/termsRepository";

const termsList = createAsyncStore();
const termsDetail = createAsyncStore();

const getTermsList = (locale: string, serviceId: string, searchTag?: string) => {
    termsList.onGetAll(() => TermsRepository.onGetTermsList(locale, serviceId, searchTag));
}

const getTermsDetail = (termsId: string | number) => {
    termsDetail.onGetAll(() => TermsRepository.onGetTermsDetail(termsId));
}

export const termsStore = {
    termsList,
    termsDetail,
    getTermsList,
    getTermsDetail,
}
